import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, inject, Loader } from 'Mri.Web.Common';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { AdminStore } from './AdminStore';

export interface IZendeskSettingsProps extends RouteComponentProps<undefined> {}

@autoinject
@observer
export class ZendeskSettings extends React.Component<IZendeskSettingsProps> {
    public render() {
        return (
            <div className="container">
                <div className="card">
                    <div className="card-body">
                        <a onClick={this.refreshZendesk} className="btn btn-primary mb-3">
                            <Loader loading={this.loading} message="Refreshing..." />
                            {!this.loading && <span>Refresh Zendesk</span>}
                        </a>
                        <p>
                            This will trigger a background task to clear and re-read all cached Zendesk tickets in the
                            orleans cluster. The orleans cluster will continue to operate during the refresh. However
                            there is no progress bar or notification while the refresh is occuring. The refresh can take
                            upwards of 30 mins.
                        </p>

                        <a onClick={this.refreshHelpcenter} className="btn btn-primary mb-3">
                            <Loader loading={this.loading} message="Refreshing..." />
                            {!this.loading && <span>Refresh Help Center</span>}
                        </a>
                        <p>
                            This will trigger a background task to clear and re-read all cached help center articles in
                            the orleans cluster. The orleans cluster will continue to operate during the refresh.
                            However there is no progress bar or notification while the refresh is occuring. The refresh
                            can take upwards of 30 mins.
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    @bind
    @action
    private async refreshZendesk(event: React.MouseEvent<HTMLAnchorElement>) {
        this.loading = true;

        try {
            await this.adminStore.refresh('zendesk');
        } catch (e: any) {
            console.log(e);
        } finally {
            this.loading = false;
        }
    }

    @bind
    @action
    private async refreshHelpcenter(event: React.MouseEvent<HTMLAnchorElement>) {
        this.loading = true;

        try {
            await this.adminStore.refresh('helpcenter');
        } catch (e: any) {
            console.log(e);
        } finally {
            this.loading = false;
        }
    }

    @observable
    private loading: boolean = false;
    @inject
    private adminStore!: AdminStore;
}
